<template>
<v-card>
  <!--
  TODO:
  * only show for the client owner (otherwise it must be the logged in user)
  <practitioner-picker v-if='!logId' v-model='practitioner' />
  <v-divider /> -->
  <v-card-text>
    <v-form >
      <v-layout >
        <v-flex>
          <v-dialog
            v-model="dialogs.icd10"
            :fullscreen='$vuetify.breakpoint.xs' >
            <v-system-bar :color='themeColor' class='visible-ios-only main' ></v-system-bar>
            <v-toolbar dark dense short :color='themeColor' >
              <v-toolbar-title >{{ $t('dialogs.titles.icd10picker') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click='dialogs.icd10=false' ><v-icon>close</v-icon></v-btn>
            </v-toolbar>
            <v-card flat>
              <icd-picker
                @input='setIcdCode'
                :initial-search-string='codeSearchString' >
              </icd-picker>
              <v-card-actions >
                <v-spacer></v-spacer>
                <v-btn @click='dialogs.icd10=false' flat >Done</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-text-field
            append-icon="search"
            box
            @click:append='showICDPicker'
            v-model='treatmentlog.icd10' label='icd10 code' class='mr-1' ></v-text-field>
        </v-flex>

        <v-flex>
          <v-dialog
            v-model="dialogs.process"
            :fullscreen='$vuetify.breakpoint.xs' >
            <v-system-bar :color='themeColor' class='visible-ios-only main' ></v-system-bar>
            <v-toolbar dark dense short :color='themeColor' >
              <v-toolbar-title >{{ $t('dialogs.titles.processpicker') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click='dialogs.process=false' ><v-icon>close</v-icon></v-btn>
            </v-toolbar>
            <v-card flat>
              <process-code-picker
                :initial-search-string='processSearchString'
                @input='setProcessCode' >
              </process-code-picker>

              <v-card-actions >
                <v-spacer></v-spacer>
                <v-btn @click='processcodepicker=false' flat >{{ $t('buttons.done') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-text-field
            @click:append='showProcessPicker'
            append-icon="search"
            v-model='treatmentlog.process' box
            class='mr-1'
            label='process code' >
          </v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field
            type='number'
            :prefix="currency"
            v-model='treatmentlog.price' box
            label='price' >
          </v-text-field>
        </v-flex>
      </v-layout>

      <v-subheader class='pl-0' >{{ $t('subtitles.dates') }}</v-subheader>
      <v-layout >
        <v-flex xs6 >
          <v-dialog
            v-model="dialogs.startdate"
            persistent lazy full-width
            width="290px" >
            <v-card flat>
              <v-date-picker
                class='elevation-0'
                v-model="treatmentlog.start_date" scrollable >
              </v-date-picker>
              <v-card-actions>
                <v-btn
                  @click='dialogs.startdate = false'
                  flat small >{{ $t('buttons.cancel') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-text-field
            v-model='treatmentlog.start_date'
            persistent-hint readonly
            :label='$t("fields.labels.started")'
            :hint='$t("fields.hints.started")'
            @click='dialogs.startdate=true'
            @click:prepend='dialogs.startdate=true'
            prepend-icon="event" >
          </v-text-field>

        </v-flex>
        <v-flex xs6 >
          <v-dialog
            v-model="dialogs.stopdate"
            persistent lazy full-width
            width="290px" >
            <v-card flat>
              <v-date-picker
                class='elevation-0'
                :min='treatmentlog.start_date'
                v-model="treatmentlog.stop_date" scrollable >
              </v-date-picker>
              <v-card-actions>
                <v-btn
                  @click='dialogs.stopdate = false'
                  flat small >{{ $t('buttons.cancel') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-text-field
            v-model='treatmentlog.stop_date'
            persistent-hint readonly clearable
            :label='$t("fields.labels.end_date")'
            :hint='$t("fields.hints.end_date")'
            @click='dialogs.stopdate=true'
            @click:prepend='dialogs.stopdate=true'
            prepend-icon="event" >
          </v-text-field>

        </v-flex>
      </v-layout>

      <v-layout >
        <v-flex xs12 >
          <!-- :disabled="!treatmentlog.is_current" -->
          <v-checkbox
            v-model='treatmentlog.automatically_add_to_appointments'
            class='pa-0'
            persistent-hint
            :label="$t('fields.labels.auto')"
            :hint="$t('fields.hints.auto')" >
          </v-checkbox>
        </v-flex>
      </v-layout>
    </v-form>
    <!-- {{treatmentlog}} -->
  </v-card-text>
  <v-card-actions >
    <v-spacer></v-spacer>
    <v-btn
      @click='$emit("save", treatmentlog)'
      :loading="loading"
      color='primary' >
      {{ $t('buttons.save') }}</v-btn>
  </v-card-actions>
</v-card>
</template>

<script>
import IcdPicker from '@/components/pickers/IcdPicker'
import ProcessCodePicker from '@/components/pickers/ProcessCodePicker'
import PractitionerPicker from '@/components/pickers/PractitionerPicker.vue'

export default {
  name: 'ClientTreatment',
  components: {IcdPicker, ProcessCodePicker, PractitionerPicker},
  props: {
    value: { type: Object, default: () => { return { } } },
    currency: { type: String },
    touch: { type: Number, default: 0 },
    loading: { type: Boolean, default: false }
  },
  data () {
    return {
      treatmentlog: {},
      processSearchString: '',
      codeSearchString: '',
      initial: {
        icd10: '',
        process: '',
        price: 0,
        notes: '',
        is_current: true,
        automatically_add_to_appointments: false
      },
      dialogs: {
        icd10: false,
        process: false,
        startdate: false,
        stopdate: false
      },
      practitioner: {}
    }
  },
  mounted () {
    this.treatmentlog = this.initial
    if (!this.treatmentlog.start_date) {
      this.treatmentlog.start_date = this.luxonDateformat(null, 'yyyy-MM-dd')
    }
    if (this.me) {
      this.practitioner = JSON.parse(JSON.stringify(this.me))
    }
    if (!this.currency) {
      this.currency = this.defaultCurrency
    }
  },
  watch: {
    startdate () {
      this.dialogs.startdate = false
    },
    stopdate () {
      this.dialogs.stopdate = false
    },
    isCurrentDiagnosis () {
      if (this.isCurrentDiagnosis === false) {
        this.treatmentlog.automatically_add_to_appointments = false
      }
    },
    touch () {
      this.treatmentlog = this.initial
    },
    value: {
      immediate: true,
      handler () {
        if (this.value) {
          this.treatmentlog = this.value
        }
      }
    }
  },
  methods: {
    showICDPicker () {
      this.dialogs.icd10 = true
      this.codeSearchString = this.treatmentlog.icd10
    },
    setIcdCode (code) {
      this.treatmentlog.icd10 = code.name
      this.dialogs.icd10 = false
    },
    showProcessPicker () {
      this.dialogs.process = true
      this.processSearchString = this.treatmentlog.process
    },
    setProcessCode (code) {
      this.treatmentlog.process = code.name
      if (code.discovery_rate) {
        this.treatmentlog.price = code.discovery_rate
      }
      if (code.price) {
        this.treatmentlog.price = code.price
      }
      this.dialogs.process = false
    }
  },
  computed: {
    startdate () {
      return this.treatmentlog.start_date
    },
    stopdate () {
      return this.treatmentlog.stop_date
    },
    isCurrentDiagnosis () {
      return this.treatmentlog.is_current
    },
    isOwner () {
      let practitionerId = this.getObjectPath(this.treatmentlog, 'practitioner')
      return practitionerId === this.meId
    },
    logId () {
      if (this.treatmentlog && this.treatmentlog.id) {
        return this.treatmentlog.id
      }
      return null
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Add a treatment log',
        fields: {
          labels: {
            current: 'Is current diagnosis',
            auto: 'Automatically add to new appointmentments',
            started: 'Start date',
            end_date: 'End date'
          },
          hints: {
            current: 'Indicates that this is current diagnosis and treatment for this patient',
            auto: 'When you create new appointments for this client, we will automatically add these codes',
            started: 'The date when you started this treatment plan for this client',
            end_date: 'The date when this path of treatment finishes'
          }
        },
        subtitles: {
          notes: 'Notes',
          dates: 'Treatment dates'
        },
        notices: {
          finishedisdisabled: 'Cannot set finished date for current treatment logs'
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ClientTreatment.vue?23cb3a2d